// ======================================================================
// File Name       : UserHistoryStudentResultDrillInfo
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import React from 'react';
import { Form, FormControl, Col, InputGroup, Button } from 'react-bootstrap';

class UserHistoryStudentResultDrillInfo extends React.Component {
  render() {
    // #6801 START
    const {
      drillSecernId, drillExeTime, drillName, learningRecord,
      drillResultExp, drillResultNum, perfectPoint, questionCount,
    } = this.props.drillResultByStd;

    const scoringMethod = parseInt(drillResultExp, 10);
    let learningResult = `${drillResultNum}/${questionCount} 問`;
    if (scoringMethod === 1) {
      learningResult = `${drillResultNum} ％`;
    } else if (scoringMethod === 2) {
      learningResult = `${drillResultNum}/${perfectPoint} 点`;
    }
    // #6801 END
    return (
      <Col sm={12}>
        <div className="margin-top-10 margin-bottom-10"><h3>ドリル履歴詳細情報</h3></div>
        <Col sm={12}>
          <Form className='form-horizontal'>
            <Form.Group className="form-info">
              <Col as={Form.Label} sm={3}>
                ドリル識別ID
              </Col>
              <Col sm={9} as={Form.Label}>
                {drillSecernId}
              </Col>
            </Form.Group>
            <Form.Group className="form-info">
              <Col as={Form.Label} sm={3}>
                ドリル名
              </Col>
              <Col sm={9} as={Form.Label}>
                {drillName}
              </Col>
            </Form.Group>
            <Form.Group className="form-info">
              <Col as={Form.Label} sm={3}>
                学習時間
              </Col>
              <Col sm={9} as={Form.Label}>
                {drillExeTime}{' '}秒
              </Col>
            </Form.Group>
            <Form.Group className="form-info">
              <Col as={Form.Label} sm={3}>
                学習実績
              </Col>
              <Col sm={9} as={Form.Label}>
                {/* #6801 */}
                {learningResult}
              </Col>
            </Form.Group>
          </Form>
        </Col>
      </Col>
    );
  }
}

export default UserHistoryStudentResultDrillInfo;
